import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    borderRadius: '8px !important',
    minWidth: '320px',
    // *: Cap to the viewport and clip overflow -- without this the box grows to fit
    // *: all sections and the Continue button (pinned to its bottom) renders off-screen
    // *: on short mobile viewports, with nothing to scroll to reach it.
    maxHeight: 'calc(100vh - 32px)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    background: '#FFF',
  },
  content: {
    display: 'flex',
    width: 'min(596px, 100vw - 32px)',
    height: 'auto',
    // *: Fill the remaining space in the capped column and allow it to shrink below
    // *: its content size -- required for overflowY: auto to actually activate instead
    // *: of the box growing past modalContent's maxHeight.
    flex: '1 1 auto',
    minHeight: 0,
    padding: '4px',
    overflowY: 'auto',
    overflowX: 'hidden',
    background: '#FFF',
    pb: '100px',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    height: 'auto',
    gap: '8px',
    padding: '8px',
    borderRadius: '8px',
    background: theme.palette.secondary.main,
  },
  header: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      padding: '24px 16px',
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      gap: '4px',
      flex: '1 0 0',
      background: '#FFF',
      borderTopLeftRadius: '8px',
      borderTopRightRadius: '8px',
    },
    title: {
      fontSize: '24px',
      fontWeight: 600,
    },
    subTitle: {
      color: theme.palette.grey[400],
      fontSize: '14px',
      fontWeight: 500,
    },
  },
});

export default useStyles;
